module.exports = __webpack_public_path__ + "img/gartek-services-due-diligences-studies.33c74dd7.jpeg";